import React, { useState, useContext } from "react";
import { fetchUsers } from "../api/api";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { UserContext } from "../context/UserContext";

const Login = () => {
  const { saveUser } = useContext(UserContext); // Access saveUser from context
  const [formData, setFormData] = useState({
    username: "",
    password: "password",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = formData;

    // Call the mock API to fetch users
    const user = await fetchUsers(username);

    // Simulate checking user credentials (password check is simplified for now)

    if (user && password === "password") {
      // Save the user data to context and localStorage
      saveUser(user.emailId);

      // Redirect to QCPanel route on successful login
      if (user.role === "Member") {
        if (user.team_id === "A") {
          navigate("/teamA");
        } else if (user.team_id === "B") {
          navigate("/teamB");
        } else if (user.team_id === "C") {
          navigate("/teamC");
        }
      } else if (user.team_id === "D") {
        navigate("/teamD");
      } else {
        navigate("/teamlead");
      }
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center ">
      <div className="card p-4" style={{ width: "20rem" }}>
        {/* <div className="flex justify-center items-center overflow-hidden">
          <img src="/growindigologo.png" alt="Logo" className="img-fluid" />
        </div> */}
        <p className="text-center mb-4" style={{ color: "#1DA5B1" }}>
          Login for testing
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <div className="d-grid gap-2">
            <button
              type="submit"
              className="btn"
              style={{ backgroundColor: "#1DA5B1", color: "white" }}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
